import React from 'react';

export const Next = ({ style }: { style?: React.CSSProperties }) => (
  <svg
    width="24"
    style={style}
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 20L16 12.2286L8 4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
